import { Component, OnInit } from '@angular/core';
import {HssResponse} from '../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../services/rest-api/HssErrorResponse';
import {InfoApiService} from '../../../services/rest-api/info.api.service';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {SeoService} from '../../../services/seo/seo.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  toggleNavbar = true;
  departmentData: any[] = [];
  staffCategoryData: any[] = [];

  constructor(private _info: InfoApiService,
              private _actRoute: ActivatedRoute,
              private router: Router,
              private seo: SeoService) {

    this._actRoute.paramMap.subscribe(params => {
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.getDepartments();
    this.getStaffCategories();
  }

  navigatePage(current: string, code: string, id: string, external_url?: string) {
    if (current === 'home') {
      this.router.navigate(['/home']);

    } else if (current === 'department') {
      if(external_url==null || external_url==""){
        this.router.navigate(['/department/' + code + '/' + id]);
        // set to local storage
        localStorage.setItem('currentDeptId', id);
        localStorage.setItem('currentDeptCode', code);
      } else{
        //window.location.href = external_url;
        window.open(external_url, '_blank');
      }

    }
  }

  navigateWithParams(current: string, param?: any){
    if (current === 'allstaff') {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          event: JSON.stringify(param)
        }
      };
      this.router.navigate(['/allstaff/'],navigationExtras);
    }
  }

  navigateUrl(url: any){
    window.open(url);
  }

  siteSearch(event: any){
    const val = event.target.value;

    if (event.key === "Enter") {
      this.router.navigate(['/search/' + val]);
    }


  }

  // Get departments
  getDepartments(){
    this._info.getDeptByType().subscribe (
      (response: HssResponse<any>) => {
        this.departmentData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get Staff categories
  getStaffCategories(){
    this._info.getStaffCategories().subscribe (
      (response: HssResponse<any>) => {
        this.staffCategoryData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  hideMenu(){
    this.toggleNavbar = !this.toggleNavbar;
  }


}
